<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="book-shelf-page">
        <div class="bksf-hd">
          <div class="tab-ct-list">
            <div class="item" v-for="item of categoryList" :class="{ active: item.TYPE === categoryType }"
              @click="handleCategory(item.TYPE)">
              My {{ item.NAME }}({{
                collectList.filter((o) => o.productType == item.TYPE).length
              }})
            </div>
          </div>
          <div class="opt-set" :class="{ active: isModify && !isEnable }">
            <div class="sjgl-btn" @click="handleModify">
              Edit<span class="icon iconfont icon-shezhi"></span>
            </div>
            <div class="opt-btn-list">
              <el-checkbox v-model="checked" border size="mini" class="qx-btnpl" @change="handleSelect">Select
                All</el-checkbox>
              <el-dropdown trigger="click">
                <el-button size="mini" round>Move to</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) of folderList.filter(
                    (o) => o.BUSINESSTYPE == categoryType
                  )" :key="index" v-if="item.ID != folderId" class="fdr-nmlist">
                    <div class="fd-item" @click="moveCollect(item.ID)" style="text-align: center">
                      {{ item.FOLDERNAME }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="mini" round @click="removeCollect">Delete</el-button>
              <el-button size="mini" round @click="handleModify">Finish</el-button>
            </div>
          </div>
        </div>
        <div class="bksf-bd">
          <div class="sj-book-list">
            <div class="item folderItem" v-for="(item, index) of folderList.filter(
              (o) => o.BUSINESSTYPE == categoryType
            )">
              <div class="list-img" v-if="item.ID" @click="handleEnable(item.ID)">
                <template v-if="item.productCover">
                  <img v-for="(temp, index) of collectList.filter(
                    (o) => o.folderId == item.ID
                  )" v-if="collectList.length > 0 && index < 4" :src="temp.productCover" />
                </template>
                <template v-else><img src="/static/img/np-img.png" /></template>
              </div>
              <div class="list-img" style="text-align: center; line-height: 172px" v-if="!item.ID"
                @click="submitFolder()">
                <span class="icon iconfont icon-tianjia" style="font-size: 90px; color: #a7a6a6"></span>
              </div>
              <div class="bkname">
                {{ item.ID ? item.FOLDERNAME : "New directory" }}
              </div>
            </div>
            <el-checkbox-group v-model="checkedList">
              <div class="item" v-for="item of collectList.filter(
                (o) => o.productType == categoryType && !o.folderId
              )" @click="
  handleRouter(item)
  ">
                <div class="select" v-show="isSelect && !isEnable">
                  <el-checkbox :label="item"></el-checkbox>
                </div>
                <div class="s-img">
                  <!-- <div class="img-tag1">
                    {{ item.sourceOpenType === "01" ? "借阅" : "畅读" }}
                  </div> -->
                  <template v-if="item.productCover"><img :src="item.productCover" /></template>
                  <template v-else><img src="/static/img/np-img.png" /></template>
                  <!-- <span class="img-tag-zi">{{
                    item.productType == 1 ? "电子书" : "有声书"
                  }}</span> -->
                </div>
                <div class="bkname">{{ item.productName }}</div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
    <div class="bookslf-toast" v-show="isEnable">
      <div class="toast-bg" @click="handleEnable"></div>
      <div class="toast-body">
        <div class="toast-head">
          <div class="floder-name-input">
            <div class="toast-close" @click="handleEnable">
              <i class="el-icon-back"></i>
              back
            </div>
            <el-dropdown trigger="click">
              <el-button class="fld-name" size="mini">
                <span class="icon iconfont icon-bianji"></span>
                {{
                  folderList.filter((o) => o.ID == folderId).length > 0
                  ? folderList.filter((o) => o.ID == folderId)[0].FOLDERNAME
                  : ""
                }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="submitFolder()">modify</el-dropdown-item>
                <el-dropdown-item @click.native="removeFolder()">delete</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="opt-set" :class="{ active: isModify }">
            <div class="sjgl-btn" @click="handleModify">
              Edit<span class="icon iconfont icon-shezhi"></span>
            </div>
            <div class="opt-btn-list">
              <el-checkbox v-model="checked" border size="mini" class="qx-btnpl" @change="handleSelect">Select
                All</el-checkbox>
              <el-dropdown trigger="click">
                <el-button size="mini" round>Move to</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) of folderList.filter(
                    (o) => o.BUSINESSTYPE == categoryType
                  )" :key="index" v-if="item.ID != folderId" class="fdr-nmlist">
                    <div class="fd-item" @click="moveCollect(item.ID)" style="text-align: center">
                      {{ item.FOLDERNAME }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="mini" round @click="removeCollect">delete</el-button>
              <el-button size="mini" round @click="handleModify">finish</el-button>
            </div>
          </div>
        </div>
        <div class="toast-folder-list" :class="{
          scroll: (isScrollBar =
            collectList.filter((o) => o.folderId == folderId).length > 10
              ? true
              : false),
        }">
          <template v-if="collectList.filter((o) => o.folderId == folderId).length > 0">
            <el-checkbox-group v-model="checkedList">
              <div class="item" v-for="item of collectList.filter(
                (o) => o.folderId == folderId
              )" @click="
  handleRouter(item)
  ">
                <div class="select" v-show="isSelect">
                  <el-checkbox :label="item" :key="item.Id"></el-checkbox>
                </div>
                <div class="s-img">
                  <!-- <div class="img-tag1">
                    {{ item.sourceOpenType === "01" ? "借阅" : "畅读" }}
                  </div> -->
                  <template v-if="item.productCover"><img :src="item.productCover" /></template>
                  <template v-else><img src="/static/img/np-img.png" /></template>
                  <!-- <span class="img-tag-zi">{{
                    item.productType == 1 ? "电子书1" : "有声书"
                  }}</span> -->
                </div>
                <div class="bk-name">{{ item.productName }}</div>
              </div>
            </el-checkbox-group>
          </template>
          <template v-else>
            <div class="nodata">
              <img src="/static/img/fdnodata.png" />
              <div class="ts">NULL</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
export default {
  name: "Bookshelf",
  components: {
    CommonHead,
    CommonFoot,
  },
  data() {
    return {
      categoryType: "1",
      categoryList: [],
      folderIndex: 0,
      folderId: null,
      folderList: [],
      collectList: [],
      checked: false,
      checkedList: [],
      isSelect: false, //是否选中
      isModify: false, //是否编辑
      isEnable: false, //是否弹窗
      isScrollBar: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted: function () {
    var params = {
      orgId: this.$fun.getMember().orgId,
      isCategory: true,
      isParent: true,
    };
    this.$bti.GetColumnTypeList(params).then((res) => {
      if (res.data.length == 0) {
        return;
      }
      this.categoryList = res.data;
      this.categoryType = res.data[0].TYPE;
      this.loadData();
    });
  },
  methods: {
    //电子书、有声书、期刊　书架切换
    handleCategory(categoryType) {
      this.categoryType = categoryType;
      // this.loadData();
      this.clearStatus();
    },
    loadData: function () {
      this.folderList = [];
      this.folderList.push({
        ID: null,
        FOLDERNAME: "书架首页",
        BUSINESSTYPE: 1,
        CollectList: [],
      });
      this.folderList.push({
        ID: null,
        FOLDERNAME: "书架首页",
        BUSINESSTYPE: 2,
        CollectList: [],
      });
      this.$bti.GetBookShelfList().then((res) => {
        if (res.code != 1) {
          return;
        }
        this.folderList.push(...res.data.FolderList);
        this.collectList = res.data.CollectList;
      });
    },
    submitFolder() {
      this.$prompt(
        "Please input directory name",
        (this.folderId ? "Modify" : "New") + " directory",
        {
          confirmButtonText: "sure",
          cancelButtonText: "cancel",
          inputValue: this.folderId
            ? this.folderList.filter((o) => o.ID == this.folderId)[0].FOLDERNAME
            : "",
          beforeClose: (action, instance, done) => {
            if (action !== "confirm") {
              done();
              return;
            }
            var params = {
              ID: this.folderId,
              FOLDERNAME: instance.inputValue,
              BUSINESSTYPE: this.categoryType,
            };
            this.$bti.SubmitFolder(params).then((res) => {
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.data,
              });
              if (res.code != 1) {
                return;
              }
              done();
            });
          },
        }
      )
        .then(() => {
          this.loadData();
        })
        .catch(() => { });
    },
    removeFolder() {
      this.$bti.RemoveFolder({ ID: this.folderId }).then((res) => {
        this.$message({
          type: res.code == 1 ? "success" : "error",
          message: res.data,
        });
        if (res.code != 1) {
          return;
        }
        this.handleEnable();
        this.loadData();
      });
    },
    removeCollect: function () {
      var params = {
        productIds: this.getSelectedIds(),
      };
      if (params.productIds.length == 0) {
        this.$message({ type: "error", message: "请先选择移除的内容!" });
        return;
      }
      this.$bti.RemoveCollect(params).then((res) => {
        this.$message({
          type: res.code == 1 ? "success" : "error",
          message: res.data,
        });
        if (res.code != 1) {
          return;
        }
        this.checked = false;
        this.checkedList = [];
        this.loadData();
      });
    },
    moveCollect: function (folderId) {
      var params = {
        productIds: this.getSelectedIds(),
        folderId: folderId ? folderId : "",
      };
      if (params.productIds.length == 0) {
        this.$message({ type: "error", message: "请先选择移动的内容!" });
        return;
      }
      this.$bti.MoveCollect(params).then((res) => {
        this.$message({
          type: res.code == 1 ? "success" : "error",
          message: res.info,
        });
        if (res.code != 1) {
          return;
        }
        this.checked = false;
        this.checkedList = [];
        this.loadData();
      });
    },
    getSelectedIds: function () {
      var ids = [];
      this.checkedList.forEach(function (item) {
        ids.push(item.productId);
      });
      return ids;
    },
    // 打开文件夹
    handleEnable(id) {
      this.isEnable = !this.isEnable;

      if (this.isEnable) {
        this.folderId = id;
      } else {
        this.folderId = null;
      }
      this.clearStatus();
    },
    // 操作编辑
    handleModify() {
      this.isModify = !this.isModify;
      if (this.isModify) {
        this.isSelect = true;
      } else {
        this.clearStatus();
      }
    },
    handleSelect() {
      this.checkedList = this.checked
        ? this.collectList.filter((o) => o.folderId == this.folderId)
        : [];
    },
    handleRouter(row) {
      var params = {
        Id: row.productId,
        type: row.productType,
        status: row.sourceOpenType
      };
      //看书
      if (this.isModify) {
        return;
      }
      if (row.bookId == "0") {
        this.$router.push({
          path: this.$fun.getProductUrl(row.productId, this.categoryType),
        });
        return;
      }
      this.$fun.openJdReadBook(row.productId, row.bookId, "2");

      //老的权限控制
      // this.$bti.GetReadBook(params).then((res) => {
      //   if (!res.data) {
      //     this.$message({ type: "error", message: "this book deleted!" });
      //     return;
      //   } else {
      //     if (this.isModify) {
      //       return;
      //     }
      //     if (row.bookId == "0") {
      //       this.$router.push({
      //         path: this.$fun.getProductUrl(row.productId, this.categoryType),
      //       });
      //       return;
      //     }
      //     this.$fun.openJdReadBook(row.productId, row.bookId, "2");
      //   }
      // });
    },
    clearStatus() {
      this.isModify = false;
      this.isSelect = false;
      this.checked = false;
      this.checkedList = [];
    },
  },
};
</script>

<style lang="css" scoped>
.book-shelf-page {
  margin-bottom: 50px;
  background: #fff;
  padding: 40px;
  min-height: 580px;
}

.bksf-hd:after,
.bksf-hd .tab-ct-list:after,
.sj-book-list:after,
.sj-book-list .item.folderItem .list-img:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.bksf-hd {
  position: relative;
}

.bksf-hd .tab-ct-list {
  float: left;
  width: 640px;
}

.opt-set {
  position: absolute;
  right: 0;
  top: 0;
}

.bksf-hd {
  border-bottom: 2px solid #e7e4e4;
}

.bksf-hd .tab-ct-list .item {
  float: left;
  font-size: 18px;
  padding-right: 60px;
  padding-bottom: 20px;
  cursor: pointer;
}

.bksf-hd .tab-ct-list .item.active {
  position: relative;
  color: #ed6b42;
}

.bksf-hd .tab-ct-list .item.active:after {
  border: solid 2px #e7e4e4;
  border-bottom-width: 0;
  border-left-width: 0;
  content: " ";
  bottom: -24px;
  left: 20%;
  position: absolute;
  width: 20px;
  height: 20px;
  -webkit-transform: translateY(-50%) rotate(135deg);
  transform: translateY(-50%) rotate(135deg);
  background: #fff;
}

.sj-book-list {
  padding: 50px 0px;
}

.sj-book-list .item {
  float: left;
  width: 130px;
  position: relative;
  margin: 10px 28px;
}

.sj-book-list .item .select {
  position: absolute;
  top: 5px;
  left: 5px;
  /*background: #fff;*/
  width: 24px;
  height: 24px;
  /*border-radius: 100%;*/
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  overflow: hidden;
}

.sj-book-list .item .select .icon {
  font-size: 32px;
  position: relative;
  left: -3px;
  top: 1px;
}

.sj-book-list .item .select .icon-xuanze1 {
  color: #bbb;
  font-weight: bold;
}

.sj-book-list .item .select .icon-xuanze {
  color: red;
}

.sj-book-list .item .s-img,
.sj-book-list .item .list-img {
  width: 100%;
  height: 172px;
  cursor: pointer;
}

.sj-book-list .item .s-img {
  position: relative;
}

.sj-book-list .item .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.sj-book-list .item .bkname {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}

.sj-book-list .item.folderItem .list-img {
  background: #eee;
  border-radius: 6px;
  padding-top: 6px;
}

.sj-book-list .item.folderItem .list-img img {
  float: left;
  width: 48px;
  height: 60px;
  border-radius: 3px;
  margin: 10px 8px;
}

.add-folder-btn {
  width: 130px;
  height: 172px;
  border-radius: 6px;
  background: #eee;
  margin: 30px auto;
  text-align: center;
  line-height: 172px;
  cursor: pointer;
}

.add-folder-btn .icon {
  font-size: 90px;
  color: #a7a6a6;
}

.sjgl-btn {
  cursor: pointer;
  font-size: 18px;
  color: #777;
}

.sjgl-btn .icon {
  font-weight: bold;
  padding-left: 10px;
  font-size: 18px;
}

.opt-btn-list {
  display: none;
}

.opt-set.active .sjgl-btn {
  display: none;
}

.opt-set.active .opt-btn-list {
  display: block;
}

.opt-set.active .opt-btn-list .el-dropdown {
  margin: 0px 10px;
}

/*文件夹操作*/
.bookslf-toast {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  z-index: 1110;
}

.bookslf-toast .toast-bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1111;
}

.bookslf-toast .toast-body {
  position: relative;
  background: #fff;
  width: 885px;
  height: 580px;
  z-index: 1112;
  /*padding-top: 40px;*/
}

.bktst-tp {
  position: relative;
  height: 50px;
  line-height: 50px;
}

.bktst-tp .cl-name {
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 18px;
}

.bktst-tp .cl-name .icon {
  font-size: 21px;
  color: #f7cf0c;
}

.bktst-tp .toast-close {
  position: absolute;
  right: 10px;
  top: -5px;
  width: 30px;
  height: 24px;
  text-align: right;
  cursor: pointer;
}

.bookslf-toast .toast-head:after,
.bookslf-toast .toast-folder-list:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.bookslf-toast .toast-head {
  position: relative;
  padding: 10px 15px 10px 15px;
  background: #eee;
}

.bookslf-toast .toast-head .floder-name-input {
  float: left;
  width: 300px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.bookslf-toast .toast-head .floder-name-input .cl-name {
  font-size: 18px;
}

.bookslf-toast .toast-head .floder-name-input .el-button {
  margin-left: 15px;
}

.bookslf-toast .toast-head .opt-set {
  top: 15px;
  right: 15px;
}

.bookslf-toast .toast-folder-list {
  width: 840px;
  height: 453px;
  margin: 25px auto 0px auto;
}

.bookslf-toast .toast-folder-list.scroll {
  width: 840px;
  overflow-y: scroll;
}

.bookslf-toast .toast-folder-list .item {
  position: relative;
  float: left;
  width: 120px;
  margin: 10px;
}

.bookslf-toast .toast-folder-list.scroll .item {
  width: 117px;
}

.bookslf-toast .toast-folder-list .item .s-img {
  position: relative;
  width: 100%;
  height: 173px;
}

.bookslf-toast .toast-folder-list .item .s-img img {
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bookslf-toast .toast-folder-list .item .bk-name {
  height: 35px;
  line-height: 35px;
  color: #333;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.toast-folder-list .select {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  overflow: hidden;
}

.toast-folder-list .nodata {
  margin: 0px auto;
  text-align: center;
  padding-top: 60px;
}

.toast-folder-list .swiper-container {
  width: 110%;
  height: 100%;
}

.toast-folder-list .swiper-slide {
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-right: 20px;
}

.toast-folder-list .el-checkbox-group {
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #9b9595;
}

.floder-name-input .icon-bianji {
  color: #03a9f4;
  padding-right: 5px;
  font-weight: bold;
}

.floder-name-input .fld-name {
  color: #333;
  font-weight: bold;
}

.floder-name-input .toast-close {
  position: relative;
  font-size: 14px;
  cursor: pointer;
}

.floder-name-input .toast-close .el-icon-back {
  font-size: 18px;
  padding-right: 2px;
}

.qx-btnpl {
  border-radius: 30px !important;
  background: #fff;
}

.fdr-nmlist {
  padding: 0px 8px;
  min-width: 100px;
}

.sj-book-list .item .s-img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,
      #409eff,
      #409eff 50%,
      transparent 50%,
      transparent 100%);
  color: #fff;
  font-size: 12px;
  padding-left: 19px;
}

/* .bookslf-toast .toast-folder-list .item .s-img .img-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(
    -135deg,
    #409eff,
    #409eff 50%,
    transparent 50%,
    transparent 100%
  );
  color: #fff;
  font-size: 12px;
  padding-left: 19px;
} */

/* .bookslf-toast .sj-book-list .item .s-img .img-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,#409EFF,#409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
  font-size: 12px;
} */

.bookslf-toast .item .s-img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  color: #fff;
  font-size: 12px;
  background: linear-gradient(-135deg,
      #409eff,
      #409eff 50%,
      transparent 50%,
      transparent 100%);
  padding-left: 19px;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/bookshelf/Bookshelf.vue